import React from "react";
import { Modal } from "react-bootstrap";
// import CloseIcon from '@mui/icons-material/Close';
import { URLS } from "../../urls";
import CloseIcon from "mdi-react/CloseIcon";

export const DocumentationModal = ({
  showDocumentationModal,
  setShowDocumentationModal,
  selectedProject,
}) => {
  return (
    <Modal
      show={showDocumentationModal}
      onHide={() => setShowDocumentationModal(false)}
      size="lg"
      centered
      backdropClassName="global-backdrop"
    >
      <Modal.Header>
        <Modal.Title>API Documentation - Create Customer</Modal.Title>
        <button
          className="btn-close"
          onClick={() => setShowDocumentationModal(false)}
          style={{ background: "none", border: "none", fontSize: "1.5rem" }}
        >
          <CloseIcon />
        </button>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div className="api-documentation">
          <h5>Endpoint</h5>
          <div className="bg-light p-3 rounded mb-3">
            <code>
              POST {URLS.backendExternalCrm}/create-lead/
              {selectedProject?._id || "PROJECT_ID"}
            </code>
          </div>

          <h5>Description</h5>
          <p>
            This endpoint allows you to create a new lead/prospect for the
            selected pipeline project.
          </p>

          <h5>Headers</h5>
          <div className="bg-light p-3 rounded mb-3">
            <code>
              Content-Type: application/json
              <br />
              {/* Authorization: Bearer YOUR_TOKEN_HERE */}
            </code>
          </div>

          <h5>Request Body</h5>
          <div className="bg-light p-3 rounded mb-3">
            <pre style={{ fontSize: "0.875rem", margin: 0 }}>
              {`{
  "leadName": "ACME Corp",
  "leadDetail": "Plot 8a, admirality way, Lekki Phase 1, Lagos",
  "leadDesc": "the short description",
  "leadWebsiteAddress": "www.acme.com",
  "startDate": "28/08/2025",
  "dueDate": "29/08/2025",
  "customerType": "wholeseller",
  "aboutUs": "Bill board",
  "productInterest": "InvexERP",
  "name": {
    "first": "John",
    "last": "Deo"
  },
  "email": "johndeo@acme.com",
  "phone": "08081602424",
  "position": "CEO",
  "message": "I'll like to know more about your product.",
}`}
            </pre>
          </div>

          <h5>Field Descriptions</h5>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Type</th>
                  <th>Required</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>leadName</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>Name of the lead/customer</td>
                </tr>
                <tr>
                  <td>leadDetail</td>
                  <td>String</td>
                  <td>No</td>
                  <td>Detailed address or location</td>
                </tr>
                <tr>
                  <td>leadDesc</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>Short description of the lead</td>
                </tr>
                <tr>
                  <td>leadWebsiteAddress</td>
                  <td>String</td>
                  <td>No</td>
                  <td>Customer's website URL</td>
                </tr>
                <tr>
                  <td>startDate</td>
                  <td>String</td>
                  <td>No</td>
                  <td>Start date in DD/MM/YYYY format</td>
                </tr>
                <tr>
                  <td>dueDate</td>
                  <td>String</td>
                  <td>No</td>
                  <td>Due date in DD/MM/YYYY format</td>
                </tr>
                <tr>
                  <td>customerType</td>
                  <td>string</td>
                  <td>No</td>
                  <td>
                    Type of customer: "Walk In", "wholeseller", "distributors",
                    "orders"
                  </td>
                </tr>
                <tr>
                  <td>aboutUs</td>
                  <td>String</td>
                  <td>No</td>
                  <td>How they heard about you</td>
                </tr>
                <tr>
                  <td>productInterest</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>Product they're interested in</td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>
                    Status: "AWAITING", "INCOMPLETE", "UNDER_REVIEW",
                    "COMPLETE", "DONE"
                  </td>
                </tr>
                <tr>
                  <td>name.first</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>Customer's first name</td>
                </tr>
                <tr>
                  <td>name.last</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>Customer's last name</td>
                </tr>
                <tr>
                  <td>email</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>Customer's email address</td>
                </tr>
                <tr>
                  <td>phone</td>
                  <td>String</td>
                  <td>Yes</td>
                  <td>Customer's phone number</td>
                </tr>
                <tr>
                  <td>position</td>
                  <td>String</td>
                  <td>No</td>
                  <td>Customer's job position</td>
                </tr>
                <tr>
                  <td>message</td>
                  <td>String</td>
                  <td>No</td>
                  <td>A message from the customer</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h5>Response</h5>
          <div className="bg-light p-3 rounded mb-3">
            <pre style={{ fontSize: "0.875rem", margin: 0 }}>
              {`{
  "success": true,
  "task": {
    "_id": "customer_id",
    "taskName": "HayZedd",
    "email": "adebayoazeez37@yahoo.com",
    // ... other customer fields
  },
  "updatedProject": {
    "_id": "project_id",
    "name": "Pipeline Name",
    // ... other project fields
  }
}`}
            </pre>
          </div>

          <h5>Example Usage (JavaScript)</h5>
          <div className="bg-light p-3 rounded mb-3">
            <pre style={{ fontSize: "0.875rem", margin: 0 }}>
              {`fetch('${URLS.backendExternalCrm}/create-lead/${
                selectedProject?._id || "PROJECT_ID"
              }', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    leadName: "John Doe Company",
    leadDetail: "123 Business Street, City",
    leadDesc: "Potential client for software development",
    leadWebsiteAddress: "johndoe.com",
    startDate: "28/08/2025",
    dueDate: "28/08/2025",
    customerType: "Walk In",
    aboutUs: "Google Search",
    productInterest: "Web Development",
    status: "AWAITING",
    project: "${selectedProject?._id || "PROJECT_ID"}",
    name: {
      first: "John",
      last: "Doe"
    },
    email: "john@johndoe.com",
    phone: "1234567890",
    position: "CEO",
    message: "I'll like to know more about your product.",
  })
})
.then(response => response.json())
.then(data => console.log(data))
.catch(error => console.error('Error:', error));`}
            </pre>
          </div>

          <h5>Example Usage (cURL)</h5>
          <div className="bg-light p-3 rounded mb-3">
            <pre style={{ fontSize: "0.875rem", margin: 0 }}>
              {`curl -X POST "${URLS.backendExternalCrm}/create-lead/${
                selectedProject?._id || "PROJECT_ID"
              }" \\
  -H "Content-Type: application/json" \\
  -d '{
    "leadName": "John Doe Company",
    "leadDetail": "123 Business Street, City",
    "leadDesc": "Potential client for software development",
    "leadWebsiteAddress": "johndoe.com",
    "startDate": "28/08/2025",
    "dueDate": "28/08/2024",
    "customerType": "Walk In",
    "aboutUs": "Google Search",
    "productInterest": "Web Development",
    "status": "AWAITING",
    "project": "${selectedProject?._id || "PROJECT_ID"}",
    "name": {
      "first": "John",
      "last": "Doe"
    },
    "email": "john@johndoe.com",
    "phone": "1234567890",
    "message": "I'll like to know more about your product.",
    "position": "CEO"
  }'`}
            </pre>
          </div>

          <h5>Error Responses</h5>
          <div className="bg-light p-3 rounded">
            <pre style={{ fontSize: "0.875rem", margin: 0 }}>
              {`// 400 Bad Request
{
  "success": false,
  "message": "Validation error message"
}


// 404 Not Found
{
  "success": false,
  "message": "Project not found"
  }
  
  // 500 Internal Server Error
  {
    "success": false,
    "message": "Internal server error"
    }`}
              {/* // 401 Unauthorized
    {
      "success": false,
      "message": "Invalid or missing token"
    } */}
            </pre>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => setShowDocumentationModal(false)}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
